<template>
  <div>
    <player-search @select="selectPlayer" />

    <line-separator>OR</line-separator>

    <select-input
      v-model="indexId"
      label="Choose an index"
      searchable
      :options="indexOptions"
      @input="selectIndex"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import PlayerSearch from '@/cards/PlayerSearch';

export default {
  components: {
    PlayerSearch,
  },

  data() {
    return {
      indexId: null,
    };
  },

  computed: {
    ...mapState({
      indexSnapshot: (state) => state.indexSnapshot,
    }),

    indexOptions() {
      const options = [];

      Object.keys(this.indexSnapshot).forEach((key) => {
        const index = this.indexSnapshot[key];

        options.push({
          label: index.label,
          icon: index.icon,
          value: key,
        });
      });

      return options;
    },
  },

  methods: {
    selectPlayer(player) {
      this.$emit('selectPlayer', player);
    },

    selectIndex(index) {
      this.$emit('selectIndex', index);
    },

    clear() {
      this.indexId = null;
    },
  },
};
</script>
